import { useQuery } from '@tanstack/react-query';
import { ACCESSORY_SUPPLIER } from '../constants/queryKeys';
import useAxiosPrivate from './useAxiosPrivate';

export default function useAccessorySupplier() {
  const axios = useAxiosPrivate();

  async function fetchIsAccessorySupplier(): Promise<boolean> {
    const res = await axios.get('/supplier-settings/is-accessory-supplier');
    return res.data;
  }

  return useQuery({
    queryKey: [ACCESSORY_SUPPLIER],
    queryFn: fetchIsAccessorySupplier,
  });
}
